import React from "react";
import { useStores } from "../../store";

export default function MockTestSummary() {
  const { MockStore } = useStores();
  const renderSuggestionWithBold = () => {
    return MockStore.report?.summary?.split("\n").map((line, index) => {
      const colonIndex = line.indexOf(":");
      if (colonIndex !== -1) {
        const beforeColon = line.substring(0, colonIndex + 1); // Include the colon in the bold text
        const afterColon = line.substring(colonIndex + 1); // Adjust to start after the colon
        return (
          <div key={index}>
            <strong>{beforeColon}</strong>
            {afterColon}
          </div>
        );
      }
      return <div key={index}>{line}</div>;
    });
  };

  return (
    <div className="mt-5">
      <h1 style={{ fontSize: "2rem", color: "#FF6B00" }}>Summary</h1>
      <div style={{ whiteSpace: "pre-wrap" }}>{renderSuggestionWithBold()}</div>
      {/* <div>
                <div className="mt-5">
                    <p className="text-gray-500"><span className="font-semibold text-black ">1.Clarity in Communication:</span> Ensure to express your thoughts and experiences more clearly and concisely. This will help the interviewer understand your skills and experiences better.</p>
                </div>
                <div className="mt-5">
                            <p className="text-gray-500">
                            <span className="font-semibold text-black">2. Technical Details:</span>  When discussing projects or experiences, try to include more technical details about the tools and methodologies you used. This will demonstrate your technical proficiency  </p>
                </div>
                <div className="mt-5">
                    <p className="text-gray-500">
                    <span className="font-semibold text-black">3. Handling Feedback:</span>  Try to provide more specific examples of how you've handled feedback and made changes to your designs, including how you communicated with the client/team during this process.         </p>
                </div>
                <div className="mt-5">
                    <p className="text-gray-500">
                        <span className="font-semibold text-black">4. Staying Updated:</span> : It's great that you stay updated with trends and technologies. Consider adding professional development activities such as attending workshops, webinars, or courses to further enhance your skills.              </p>
                </div>

                <div className="mt-5">
                <p className="text-gray-500">
                    <span className="font-semibold text-black">5.Expectations:</span> It's important to have clear expectations from your role. Try to think beyond just approval of your designs. Consider aspects like learning opportunities, growth, team collaboration, and company culture.         </p>
                </div>

                <div className="mt-5">
                    <p className="text-gray-500">
                        <span className="font-semibold text-black">6. Time Management:</span>  Provide more details on your strategies for managing time and resources during tight deadlines. This will demonstrate your project management skills. </p>
                </div>

                <div className="mt-5">
                    <p className="text-gray-500">
                        <span className="font-semibold text-black">7. Portfolio:</span>  Make sure to maintain an updated portfolio showcasing your best work and the range of your skills. This will give potential employers a better understanding of your capabilities    </p>
                </div>
                
                <div className="mt-5">
                    <p className="font-semibold">Remember, these are just suggestions to help you improve. You're doing well, and with a bit more focus and preparation, you can excel in your interviews. Best of luck!</p>

                </div>

            </div> */}
    </div>
  );
}
